module.exports = __webpack_public_path__ + "static/img/companyName.c5a19e00.png";